import { ActionType, ProTable, ProTableProps } from '@ant-design/pro-table';
import { Button, Modal } from 'antd';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import IconClose from '@/assets/images/icons/icon-close.react.svg?react';
import { ReportGuideType } from '@/config/app/auth';
import { getProductId } from '@/infrastructure/product-info';
import { ReportScene } from '@/infrastructure/reporter/datong/report';
import { formatNum } from '@/infrastructure/utils/digit';
import { decimal2Percentile } from '@/infrastructure/utils/to-unit';
import FreeProductGuide, { Display, GuideType } from '@/presentation/components/free-product-guide';
import { getDistributions } from '@/presentation/components/problem-detail-analysis/api';
import { IssueType } from '@/proto/issue';
import { IDistribution, IGetDistributionReq, IssueMetricType } from '@/proto/statistics';
import styles from './index.module.scss';


interface IProps {
  token: string;
  issueType: IssueType;
}

interface ITableData extends IDistribution {
  validReportedCount: number;
}

export const TagStatisticalDistribution = (props: IProps) => {
  const { t } = useTranslation();
  const { token, issueType } = props;
  const [visible, setVisible] = useState<boolean>(false);
  const ref = useRef<ActionType>();


  const onCancel = () => {
    setVisible(false);
  };
  const buttonClick = () => {
    setVisible(true);
  };

  const load = async () => {
    const params: IGetDistributionReq = {
      productId: getProductId(),
      token,
      dimension: 'problem_tag',
      issueType,
      limit: 1000,
      metricType: IssueMetricType.ISSUE_METRIC_REPORT_COUNT,
    };
    const data =  await getDistributions(params);
    return {
      total: data?.distributions?.length || 0,
      data: data?.distributions?.map(item => ({ ...item, validReportedCount: data?.validReportedCount || 0 })) || [],
      success: true,
    };
  };

  const columns: ProTableProps<ITableData, any>['columns'] = [
    {
      title: t('问题标签'),
      dataIndex: 'field',
    },
    {
      title: t('包含问题数'),
      dataIndex: 'issueCount',
      render: (_, record) => formatNum(record?.issueCount || 0),
    },
    {
      title: t('包含个例数'),
      dataIndex: 'value',
      render: (_, record) => formatNum(record?.value || 0),
    },
    {
      title: t('包含个例占比'),
      dataIndex: 'value',
      render: (_, record) => decimal2Percentile(((record.value || 0) / record.validReportedCount), 4),
    },

  ];

  return <>
    <FreeProductGuide guideType={GuideType.POP_CONFIRM} display={Display.INLINE}
      reportGuideType={ReportGuideType.Bubble}
      reportScene={ReportScene.TagStatisticalDistribution}
    >
      <Button onClick={buttonClick}>{t('问题标签分布')}</Button>
    </FreeProductGuide>
    <Modal
      destroyOnClose
      maskClosable={false}
      closeIcon={<IconClose/>}
      footer={null}
      onCancel={onCancel}
      width={1008}
      visible={visible}
      title={t('查看问题标签分布详情')}
      className={styles.modal}>
      <div className={'mb-[16px] text-[#4A5970] text-[14px]'}>
        {t('当前筛选条件下，问题标签的分布情况：')}
      </div>
      <ProTable
        scroll={{ y: 600 }}
        pagination={false}
        className={styles.table}
        revalidateOnFocus={false}
        actionRef={ref}
        request={load}
        columns={columns}
        toolBarRender={false}
        options={false}
        search={false}
      />
    </Modal>
  </>;
};
